import {
  REQUEST_DATA,
  RECEIVE_DATA,
  UPDATE_SELECTED,
  FETCH_GDOC_DATA,
  FETCH_GDOC_DATA_ERROR,
  FETCH_GDOC_DATA_SUCCESS,
} from '../config/types';
import updateData from '../services/updateData';

export default function dataReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_DATA:
      return state;
    case RECEIVE_DATA: {
      return {
        ...state,
        ...action.data,
        isFetching: false,
      };
    }
    case UPDATE_SELECTED: {
      return {
        ...state,
        selectedDistributions: action.data.selectedDistributions,
        ...updateData(state, { ...state.selected, ...action.data }),
      };
    }
    case FETCH_GDOC_DATA: {
      return {
        ...state,
        didInvalidate: true,
        isFetching: true,
      };
    }
    case FETCH_GDOC_DATA_ERROR: {
      return {
        ...state,
        didInvalidate: false,
        isFetching: false,
        error: true,
        lastUpdated: action.receivedAt,
      };
    }
    case FETCH_GDOC_DATA_SUCCESS: {
      return {
        ...state,
        gdocData: action.data,
        didInvalidate: false,
        isFetching: false,
        lastUpdated: action.receivedAt,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/default.js